
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tanya/[questionId]/[slug]",
      function () {
        return require("private-next-pages/tanya/[questionId]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tanya/[questionId]/[slug]"])
      });
    }
  